import { makeAutoObservable } from "mobx";

class orders {
  orders = [];

  constructor() {
    makeAutoObservable(this);
  }

  setorders = (orders) => {
    this.orders = orders;
  };

  updateOrders = (newOrder) => {
    this.orders.push(newOrder)
  }

  ordersMapSelect = []

  setOrdersMapSelect = (orders) => {
    this.ordersMapSelect = orders;
  };

  notWorkersOrders = []

  setNotWorkersOrdersTwoMonth = (orders) => {
    this.notWorkersOrders = orders;
  };
}

export default orders;
